var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('organization-control-detail',{attrs:{"audit-id":_vm.auditId,"back-url":_vm.backUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }